// src/analytics/AnalyticsContext.tsx
import { createContext } from 'react';
import type { TrackingEvent, EventAttributes } from './trackingTypes';

export interface AnalyticsContextValue {
  readonly track: (event: TrackingEvent, attributes?: EventAttributes) => void;
  readonly isInitialized: boolean;
}

export const AnalyticsContext = createContext<AnalyticsContextValue | null>(null);
